// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { formatMessageWithLocale } from '../../../../utils/i18n';
import { getCharacteristicsAsAtDates } from '../../../../utils/disclaimers/comparison';
import { DISCLAIMER_KEYS } from '../../../../utils/disclaimers/constants';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const FixedIncomeMetricsDisclaimer = ({ items, showItemNames, locale }: Props) => {
  const fixedIncomeItems = items.filter(
    i =>
      !!i.disclaimers &&
      !i.disclaimers[DISCLAIMER_KEYS.FUND_FIXED_INCOME_METRICS_NOT_APPLICABLE] &&
      !i.disclaimers[DISCLAIMER_KEYS.PORTFOLIO_FIXED_INCOME_METRICS_NOT_APPLICABLE],
  );

  return (
    <DatesDisclaimer
      globalPrefix={formatMessageWithLocale('Disclaimers.FixedIncomeMetrics', locale)}
      itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
      itemDates={getCharacteristicsAsAtDates(fixedIncomeItems, locale)}
      showItemNames={showItemNames}
      locale={locale}
    />
  );
};

export default FixedIncomeMetricsDisclaimer;
